module.exports = __webpack_public_path__ + "static/img/aiRutionPage.3c69297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aiRutionPage.png
// module id = Zw7p
// module chunks = 1